import { GlobalResponseObject } from "@gtpl/shared-models/common-models";
import { AllGrnReportDto } from ".";




export class AllGrnReportResponse extends GlobalResponseObject {
    data?: AllGrnReportDto[];

    /**
     * 
     * @param status 
     * @param errorCode 
     * @param internalMessage 
     * @param data /ProductDto[]
     */
    constructor(status: boolean, errorCode: number, internalMessage: string, data?: AllGrnReportDto[]) {
        super(status, errorCode, internalMessage);
        this.data = data;
    }
}

